import { dropService } from '@/_services'
export const dropHelpers = {
  calculateUnitWeight,
  getBatchTransportsOfUnits,
  dropDelay
}
function calculateUnitWeight (unit) {
  let totalWeight = unit.weight
  // if (unit.children === null) {
  //   unit.children = []
  // }
  // if (unit.children.length > 0) {
  //   let nodes = [].slice.call(unit.children)
  //   while (nodes.length) {
  //     let node = nodes.shift()
  //     if (node.children === null) {
  //       node.children = []
  //     }
  //     if (node.children.length > 0 && node) {
  //       totalWeight += node.weight
  //       nodes = [].slice.call(node.children).concat(nodes)
  //     } else {
  //       totalWeight += node.weight
  //       if (node.items !== null) {
  //         node.items.forEach((item) => {
  //           totalWeight += item.weight
  //         })
  //       }
  //       nodes = [].slice.call(node.children).concat(nodes)
  //     }
  //   }
  //   return Number(totalWeight)
  // } else {
  //   if (unit.items !== null) {
  //     unit.items.forEach((item) => {
  //       totalWeight += item.weight
  //     })
  //   }
  // }
  return Number(totalWeight)
}
function dropDelay (t, v) {
  return new Promise(function (resolve) {
    setTimeout(resolve.bind(null, v), t)
  })
}

// function calculateUnitWeightRoundValue (value, precision = 0) {
//   precision = Math.pow(10, precision)
//   value = value / 1000
//   value = Math.ceil(value * precision) / precision
//   var parts = value.toString().split('.')
//   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
//   value = parts.join('.')
//   return value
// }

function getBatchTransportsOfUnits ({ units }) {
  const uniqueTransports = [...new Set(units.map(({ transport }) => transport))].filter((el) => el != null && el !== '')
  return new Promise((resolve, reject) => {
    Promise.all(uniqueTransports.map(async (id, index) => {
      const response = await dropService.getUnitTransportOrder({ id })
      return response.transport
    })).then((response) => {
      const transportUnits = units.map((unit) => {
        const index = response.findIndex(({ id }) => unit.transport === id)
        if (index >= 0) {
          return { ...unit, transport: response[index] }
        } else {
          return { ...unit, transport: { order: null, id: null } }
        }
      })
      resolve(transportUnits)
    }).catch((error) => {
      reject(error)
    })
  })
}
